var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlaylist = function SvgIconPlaylist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 6a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1M2.75 12a1 1 0 0 1 1-1H15a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1M3.75 17a1 1 0 1 0 0 2h6.75a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.75 15a3.25 3.25 0 1 0 2 3v-6.156l2.463.739a1 1 0 0 0 .574-1.916l-3.75-1.125a1 1 0 0 0-1.287.958zm-1.25 1.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
    clipRule: "evenodd"
  }))));
};
export default SvgIconPlaylist;